//import Vue from 'vue';
import trace from './src/trace';

import './src/navigation';

import './src/contact-block';
import './src/header-carousel';
import './src/faq';
import './src/order-confirmed';
import './src/price-list';
import './src/place-order';
import './src/preferences';
import './src/trustpilot';

import './src/dom';
import './src/responsive';

import './src/dialog-dispatcher';

const preloadManifest = [
    {
        path   : 'vectors',
        assets : [
            'spinner-inner.svg',
            'spinner-outer.svg',
        ]
    }
];

for( const batch of preloadManifest ) {
    for( const asset of batch.assets ) {
        const path = `/${batch.path}/${asset}`;
        trace.info( 'Application: preloading', path );
        ((asset) => (new Image()).src = asset)(path);
    }
}

document
    .getElementsByTagName('html')[0]
    .setAttribute( 'class', 'js-enabled' )
;

trace.info( 'Application: bootstrap complete' );




